import React from 'react';

const GoogleMap = () => {
  const mapStyle = {
    border: 0,
  };

  return (
    <div className="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3645.325439537816!2d-104.6530750266674!3d23.98428243228695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x869bb80dea58d933%3A0x826be36265133c5f!2sTOKO%20CORP!5e0!3m2!1ses!2smx!4v1772042729802!5m2!1ses!2smx"
        width="100%"
        height="100%"
        style={mapStyle}
        allowFullScreen={true}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Maps"
      />
    </div>
  );
};

export default GoogleMap;